// Fix AW (2026-10-27): roles personalizados. Un usuario con rol "custom" entra
// solo a las secciones (areas) que la administradora le marco en Equipo.
// El backend manda user.custom_areas y user.custom_role_name; el catalogo de
// areas (y su texto) viene de GET /api/roles.
export const CUSTOM_AREA_PATHS = [
  { area: "inventory", path: "/inventario" },
  { area: "payments", path: "/pagos" },
  { area: "reports", path: "/reportes" },
];

export function hasCustomArea(user, area) {
  return Boolean(user && user.role === "custom" && (user.custom_areas || []).includes(area));
}

export function customRoleName(user) {
  return (user && user.custom_role_name) || "Acceso personalizado";
}

// Primera seccion permitida; sin ninguna, la pagina de perfil.
export function customHome(user) {
  const first = CUSTOM_AREA_PATHS.find((a) => hasCustomArea(user, a.area));
  return first ? first.path : null;
}
